import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function OfflineManagerFob() {
  const navigate = useNavigate();

  const keyboardState = useRef('');
  const [fob, setFob] = useState('');

  useEffect(() => {
    const eventHandler = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        const regexSignOn = /^0100([a-z|A-Z|0-9]{12})$/gm;
        const regexSignOff = /^0{3,4}(00)$/gm;
        const regexSignOnMatch = keyboardState.current.match(regexSignOn);
        if (regexSignOnMatch !== null) setFob(regexSignOnMatch[0]);
        const regexSignOffMatch = keyboardState.current.match(regexSignOff);
        if (regexSignOffMatch !== null) setFob('');

        keyboardState.current = '';
      } else {
        if (e.key.length === 1) {
          if (keyboardState.current.length >= 16) keyboardState.current = keyboardState.current.substring(1) + e.key;
          else keyboardState.current = keyboardState.current + e.key;
        }
      }
    };

    window.addEventListener('keydown', eventHandler);
    return () => window.removeEventListener('keydown', eventHandler);
  }, []);

  const onDoneClick = () => {
    navigate('/offline-manager-pin', {
      state: { fob },
    });
  };
  return (
    <div className="pos-modal-portal">
      <div
        className="pos-modal-overlay"
        onClick={(e) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          if ((e.target as any).className === 'pos-modal-overlay') navigate('/');
        }}
      >
        <div className="pos-modal pos-modal_role_sign-in">
          <div className="pos-modal__content">
            <div className="pos-sign-in js-sign-in">
              <div className="pos-sign-in__header">
                <h2 className="pos-sign-in__title">Manager Fob</h2>
              </div>
              <div className="pos-sign-in__info">
                <p className="pos-sign-in__label">Please place your FOB on the FOB reader:</p>
              </div>
              <div className="pos-sign-in__controls">
                <div className="pos-sign-in__fob">
                  <div className="pos-field pos-field_role_fob">
                    <div className="pos-field__group">
                      <div className="pos-field__box">{fob}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pos-sign-in__actions">
                <button className="pos-sign-in__action" type="button" onClick={onDoneClick} disabled={fob.length === 0}>
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default OfflineManagerFob;
